<template>
  <v-app>
    <v-app-bar app color="grey lighten-5" elevate-on-scroll>
      <v-slide-y-transition>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="esHome"></v-app-bar-nav-icon>
          <v-btn icon v-if="!esHome" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-slide-y-transition>
      <v-toolbar-title class="headline text-uppercase">
        <span>CLUBBERS</span>
        <span class="font-weight-light">LIFESOURCE</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <router-view></router-view>
    <v-navigation-drawer v-model="drawer" fixed temporary app>
      <v-list nav dense>
        <v-list-item-group active-class="pink--text text--accent-4">
          <v-list-item>
            <v-list-item-title @click="logoff">Cerrar sesión</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Bar</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Fizz</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>Buzz</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "home",
  components: {},
  data() {
    return {
      drawer: false,
      loggedoff: false
    };
  },
  computed: {
    esHome() {
      return this.$route.path.startsWith("/home");
    }
  },
  methods: {
    ...mapActions("account", ["logout"]),
    logoff() {
      this.drawer = false;
      this.loggedoff = true;
      this.logout();
      this.$router.push({ path: "/login" });
    },
    back(){
      this.$router.go(-1);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.loggedoff) next();
    else if (this.drawer) {
      this.drawer = false;
      next(false);
    } else if (to.path.startsWith("/login/")) {
      next(false);
      if (navigator.app) {
        navigator.app.exitApp();
      }
    } else {
      next();
    }
  }
};
</script>
